import { mapGetters } from "vuex";

export const exceptionSelectionMixin = {
  inject: ["exceptionWordsApi"],

  mounted() {
    document.addEventListener("mouseup", this.handleGlobalMouseUp);
  },

  beforeDestroy() {
    document.removeEventListener("mouseup", this.handleGlobalMouseUp);
  },

  computed: {
    ...mapGetters("filterTabs", ["currentTab", "filterTabByParam"]),
  },

  methods: {
    handleGlobalMouseUp(e) {
      if (e.target.closest(".exception-popover-container")) {
        return;
      }

      const forbiddenTypes = ["ALL", "HIDDEN", "TAG"];
      if (forbiddenTypes.includes(this.currentTab?.filterType)) {
        return;
      }

      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return;

      const range = selection.getRangeAt(0);
      const linkEl = this.$refs.linkRef?.$el || this.$refs.linkRef;

      if (!linkEl) return;

      const isInside =
        linkEl.contains(range.startContainer) ||
        linkEl.contains(range.endContainer) ||
        range.intersectsNode(linkEl);

      if (isInside) {
        try {
          const linkRange = this.createNodeRange(linkEl);
          const intersectionRange = document.createRange();

          if (
            range.compareBoundaryPoints(Range.START_TO_START, linkRange) > 0
          ) {
            intersectionRange.setStart(range.startContainer, range.startOffset);
          } else {
            intersectionRange.setStart(
              linkRange.startContainer,
              linkRange.startOffset,
            );
          }

          if (range.compareBoundaryPoints(Range.END_TO_END, linkRange) < 0) {
            intersectionRange.setEnd(range.endContainer, range.endOffset);
          } else {
            intersectionRange.setEnd(
              linkRange.endContainer,
              linkRange.endOffset,
            );
          }

          const text = intersectionRange.toString().trim();
          if (!text) return;

          const rect = intersectionRange.getBoundingClientRect();

          this.exceptionWordsApi.show({
            text,
            rect,
            target: e.target,
          });
        } catch (err) {
          const text = selection.toString().trim();
          if (!text) return;

          const rect = range.getBoundingClientRect();
          this.exceptionWordsApi.show({
            text,
            rect,
            target: e.target,
          });
        }
      }
    },

    createNodeRange(node) {
      const nodeRange = document.createRange();
      nodeRange.selectNodeContents(node);
      return nodeRange;
    },
  },
};
